require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-emedicinehealth-symptoms.json") })
        }
      }, "path---article-emedicinehealth-symptoms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-emedicinehealth-symptoms!./.cache/json/article-emedicinehealth-symptoms.json
// module id = 343
// module chunks = 231608221292675